import { CONSULTATION_REPORT_V2_QUESTIONS, INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS } from "config/constants";
import { getQuestionById, isHTMLContentEmpty } from "helpers/common";
import { numberRequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, date, object, string } from "yup";

const getValidationSchema = (currentTab, reportQuestions) => {
    switch (currentTab) {
        case 1:
            return object().shape({
                screening_date: date()
                    .nullable()
                    .required('Screening date is required'),
            });
        case 2:
            //   const locationQuestion = getQuestionById(INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.location, reportQuestions);
            //   const inputLabels = locationQuestion?.question_dd_labels || [];
            //   const labelsValidation = {};
            //   inputLabels?.length && inputLabels.forEach(label => {
            //     labelsValidation[label] = stringRequiredSchema;
            //   })

            return object({
                [CONSULTATION_REPORT_V2_QUESTIONS.customEditor]: object({
                    answer: string()
                        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                        .required('This field is required'),
                }),
            });
        case 3:
            return object().shape({
                observations: array().of(
                    object().shape({
                        notes: stringRequiredSchema,
                        strategy: array().of(
                            object().shape({
                                answers: string()
                                    .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                                    .required('This field is required'),
                                // tracker_percentage: numberRequiredSchema
                            })
                        ).min(1, "Atleast 1 strategy is required."),
                        area_id: object()
                            .nullable()
                            .test('required', 'This field is required', (value) => {
                                return !!value?.value;
                            })
                    })
                ).min(1, "Atleast 1 observation is required."),
            });

        case 4:
            return object().shape({
                recommendation: array()
                    .of(
                        object().shape({
                            answers: string().test(
                                "validate-first",
                                "This field is required",
                                function (value) {
                                    const index = Number(this.path.match(/\d+/)?.[0]);

                                    // only validate the first element
                                    if (index === 0) {
                                        return !isHTMLContentEmpty(value);
                                    }
                                    return true; // others optional
                                }
                            ),
                        })
                    )
                    .min(1, "At least one recommendation is required"),
                // [CONSULTATION_REPORT_V2_QUESTIONS.diagnosis]: object({
                //     other_details: object({
                //         radio_tag: stringRequiredSchema
                //     }),
                //     answer: string().when('other_details.radio_tag', {
                //         is: 'diagnosis',
                //         then: (schema) => stringRequiredSchema,
                //         otherwise: (schema) => stringOptionalSchema,
                //     }),
                // }),
                [CONSULTATION_REPORT_V2_QUESTIONS.clinical_impressions]: object({
                    answer: stringRequiredSchema,
                }),
            });
    }
}

export default getValidationSchema;